/**
 * The TextFormat class represents character formatting information. Use the
 * TextFormat class to create specific text formatting for text fields. You
 * can apply text formatting to both static and dynamic text fields. The
 * properties of the TextFormat class apply to device and embedded fonts.
 * However, for embedded fonts, bold and italic text actually require specific
 * fonts. If you want to display bold or italic text with an embedded font,
 * you need to embed the bold and italic variations of that font.
 *
 * <p> You must use the constructor <code>new TextFormat()</code> to create a
 * TextFormat object before setting its properties. When you apply a
 * TextFormat object to a text field using the
 * <code>TextField.defaultTextFormat</code> property or the
 * <code>TextField.setTextFormat()</code> method, only its defined properties
 * are applied. Use the <code>TextField.defaultTextFormat</code> property to
 * apply formatting BEFORE you add text to the <code>TextField</code>, and the
 * <code>setTextFormat()</code> method to add formatting AFTER you add text to
 * the <code>TextField</code>. The TextFormat properties are <code>null</code>
 * by default because if you don't provide values for the properties, Flash
 * Player uses its own default formatting. The default formatting that Flash
 * Player uses for each property(if property's value is <code>null</code>) is
 * as follows:</p>
 *
 * <p>The default formatting for each property is also described in each
 * property description.</p>
 */
var TesselatedFontChar = /** @class */ (function () {
    function TesselatedFontChar(fill_data, stroke_data, fill_data_path) {
        if (fill_data === void 0) { fill_data = null; }
        if (stroke_data === void 0) { stroke_data = null; }
        if (fill_data_path === void 0) { fill_data_path = null; }
        this.fill_data = fill_data;
        this.stroke_data = stroke_data;
        this.fill_data_path = fill_data_path;
        this.fnt_channel = 0;
        /**
         * What is scale was used for generating last tesselation
         * Used for reduce a vertices count
         */
        this.lastTesselatedScale = 0;
        /**
         * the char_codes that this geom has kerning set for
         */
        this.kerningCharCodes = [];
        /**
         * the kerning values per char_code
         */
        this.kerningValues = [];
    }
    TesselatedFontChar.prototype.dispose = function () {
        if (this.stroke_data) {
            //this.stroke_data.dispose();
            this.stroke_data = null;
        }
        if (this.fill_data) {
            //this.fill_data.dispose();
            this.fill_data = null;
        }
        if (this.fill_data_path) {
            //this.fill_data_path.dispose();
            this.fill_data_path = null;
        }
    };
    return TesselatedFontChar;
}());
export { TesselatedFontChar };
